module.exports = __webpack_public_path__ + "img/djuli-report-easy.ced82f9e.gif";